module.exports = __webpack_public_path__ + "img/responsive.d8cd8086.svg";